export const WORKFLOW_LS_KEY = "workflow_templates_v1";

export type StepAction = "approve" | "reject" | "complete" | "send_back";
export type ConditionOperator = "lt" | "lte" | "gt" | "gte" | "eq" | "between";
export type DocumentType =
  | "engagement"
  | "case"
  | "task"
  | "letter"
  | "incoming_package"
  | "outgoing_package"
  | "contract"
  | "invoice_purchase"
  | "invoice_sale"
  | "other";
export type ApprovalMode = "any" | "all" | "two_or_more";

export interface Assignee {
  id: string;
  name: string;
  initials: string;
  color: string;
}

export interface WorkflowCondition {
  id: string;
  operator: ConditionOperator;
  value: number | [number, number];
  assignRole: string;
  assignees?: Assignee[];
  conditionApprovalMode?: ApprovalMode;
}

export interface WorkflowStep {
  id: string;
  order: number;
  name: string;
  description?: string;
  /** Stała formuła tekstowa opisująca ten etap w dokumencie podsumowującym procedurę. */
  documentFormula?: string;
  role: string;
  actions: StepAction[];
  conditions: WorkflowCondition[];
  assignees: Assignee[];
  approvalMode: ApprovalMode;
}

export interface WorkflowTemplate {
  id: string;
  name: string;
  /** Typ encji, do której ten workflow jest przypisany (może być wartością z DocumentType lub typem niestandardowym) */
  documentType: string;
  description?: string;
  steps: WorkflowStep[];
  isActive: boolean;
  generateMetric?: boolean;
  /** Osoby informowane o pozytywnym zakończeniu procesu (nie uczestniczą bezpośrednio w realizacji). */
  notifyOnComplete?: Assignee[];
}
